import { render, staticRenderFns } from "./EpisodeDetailsWrapper.vue?vue&type=template&id=a5126e52&"
import script from "./EpisodeDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./EpisodeDetailsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports